import React from "react";
const Q2 = () => {
  return (
    <div style={{ backgroundColor: "#Dbe6ea" }}>
      <div className="ans-bank">
        <div className="qta">Who is sponsor?</div>
        <p>
          The sponsor is Bunk4Study (“Sponsor”). Sponsor will conduct the
          Giveaway substantially as described in these Official Rules.
        </p>
      </div>
    </div>
  );
};

export default Q2;
